import { render } from "./TopDownFormPopup.vue?vue&type=template&id=2cff3111&scoped=true&ts=true"
import script from "./TopDownFormPopup.vue?vue&type=script&lang=ts"
export * from "./TopDownFormPopup.vue?vue&type=script&lang=ts"

import "./TopDownFormPopup.vue?vue&type=style&index=0&id=2cff3111&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cff3111"]])

export default __exports__